import { Subtitle } from "@components/styles"
import React, { FC } from "react"
import { GatsbyImage, getImage } from "gatsby-plugin-image"
import { NewsThumbnailItem } from "@components/LatestNews/types"
import {
    CardFooter, CardWrapper, CategoryIconWrapper, ContentWrapper, Description, ImageWrapper
} from "./styles"

const Card: FC<NewsThumbnailItem> = ({
    slug,
    publishedAt,
    thumbnail,
    category
}) => {
    const newDate = new Date(publishedAt)
    const formattedDate = newDate.toLocaleDateString("nl-NL", {
        year: "numeric",
        month: "long",
        day: "numeric"
    })

    return <CardWrapper to={`/nieuws/${slug}`}>
        {thumbnail?.image?.file?.childImageSharp?.gatsbyImageData ? <ImageWrapper>
            <GatsbyImage
                image={thumbnail?.image.file.childImageSharp.gatsbyImageData}
                alt={`${thumbnail?.image?.alternativeText}`}
            />
        </ImageWrapper> : <ImageWrapper>
            {thumbnail?.image}
        </ImageWrapper>}
        <ContentWrapper>
            <Subtitle>{thumbnail?.title}</Subtitle>
            <Description>{thumbnail?.text}</Description>
            <CardFooter>
                <span>{formattedDate}</span>
                {category?.icon && category?.icon?.file && <CategoryIconWrapper>
                    <GatsbyImage
                        alt={category?.icon?.alternativeText ?? ""}
                        image={getImage(category?.icon?.file)!}
                    />
                </CategoryIconWrapper>}
            </CardFooter>
        </ContentWrapper>
    </CardWrapper>
}

export default Card
